import {
  CreateModelCommandRequest,
  ModelCommandResponse,
  ModelCommandsClient,
  UpdateModelCommandRequest
} from "@api/apiClient";
import axios from "@api/axiosInstance";
import { queryClient } from "@hooks/useGlobalState";
import { useMutation, useQuery } from "@tanstack/react-query";

const modelCommandsClient = new ModelCommandsClient(undefined, axios);

export const useModelCommand = (name: string | undefined, options?: any) => {
  return useQuery<ModelCommandResponse[] | null>({
    ...options,
    queryKey: ["modelCommands", name],
    queryFn: async () => name ? modelCommandsClient.getModelCommands(name!) : new Promise((resolve) => resolve(null)),
  });
};

export const useCreateModelCommand = (options?: any) => {
  return useMutation<ModelCommandResponse>({
    ...options,
    mutationFn: (createModelCommandRequest: CreateModelCommandRequest) => modelCommandsClient.createModelCommand(createModelCommandRequest),
    onSuccess: async () => {
      await queryClient.resetQueries({ queryKey: ["modelCommands"], exact: false });
      options?.onSuccess?.();
    },
  });
};

export const useUpdateModelCommand = (commandId: string, options?: any) => {
  return useMutation<ModelCommandResponse>({
    ...options,
    mutationFn: (updateModelCommandRequest: UpdateModelCommandRequest) => modelCommandsClient.updateModelCommand(commandId, updateModelCommandRequest),
    onSuccess: async () => {
      await queryClient.resetQueries({ queryKey: ["modelCommands"], exact: false });
      options?.onSuccess?.();
    },
  });
};

export const useDeleteModelCommand = (options?: any) => {
  return useMutation<void>({
    ...options,
    mutationFn: (commandId: string) => modelCommandsClient.deleteModelCommand(commandId),
    onSuccess: async () => {
      await queryClient.resetQueries({ queryKey: ["modelCommands"], exact: false });
      options?.onSuccess?.();
    },
  });
};





